const useBreadcrumb = () => {
  const breadcrumbs = $('.breadcrumbs')

  breadcrumbs.each((i, el) => {
    const self = $(el)
    const items = self.find('.breadcrumbs-li')
    const itemsLen = items.length

    if (itemsLen < 3) return;

    const lastItem = $(items[itemsLen - 1])
    lastItem.addClass('clamp-1').css({ width: `${ 160 / 16 }rem` })
  })
}


export {
  useBreadcrumb
}